export enum EStatus {
    Public,
    Test,
    Deleted,
}

export enum EProducer {
    Maccaferri = 'Maccaferri',
    Other = 'Other',
}

export enum EPosition {
    Vertical,
    Horizontal,
}

export enum EBoolean {
    No,
    Yes,
}

export enum EDischargeType {
    Simple,
    Correction,
}

export enum EFSType {
    Static,
    Seismic,
}

export enum EDrainageTrenchType {
    PrimaryDrainageTrench,
    SecondaryDrainageTrench,
}

export enum EWheelbaseCheck {
    Ok,
    DependentOnSecondaryDrainageTrenches,
    NotOk,
}

export enum EUnitOfMeasure {
    Metric,
    Imperial,
}

export enum EExcavationStabilityCheck {
    VerticalExcavationReinforcementRequired,
    SelfSupportedExcavation,
}

export enum ENodeEnv {
    Development = 'development',
    Production = 'production',
}

export enum ECurrency {
    Euro,
    Dollar,
}

export enum EEngineType {
    PreliminaryCalculation,
    GeneralView,
    LongitudinalSection,
    LongitudinalStaticSection,
    LongitudinalSeismicSection,
    TransversalSectionPrimaryDrainageTrench,
    TransversalSectionSecondaryDrainageTrench,
    ResultCalculation,
}

export enum EResultCalculationType {
    Axis,
    PreFsStatic,
    PostFsStatic,
    PreFsSeismic,
    PostFsSeismic,
}

export enum EStableSlopeValidationType {
    Pre,
    Post
}

export enum ERole {
    Standard,
    Admin,
    Observer,
}